export function toSentenceCase(text) {
    if (!text) return text;
    
    // Split text into sentences
    const sentences = text.match(/[^.!?]*[.!?]*\s*/g);
    
    if (!sentences) return text;
    
    // Capitalize the first letter of each sentence
    const sentenceCased = sentences
      .map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase())
      .join(' ');
    
    return sentenceCased;
  }
  